'use strict';

import {ferry} from '../../../services/ferry/ferry';
import {validEmail} from "../../../services/constants/emailRegex";

export default ['$scope','$location', function($scope, $location) {
    $scope.email = "";
    $scope.ui = {};

    $scope.forgotDisabled = function() {
        return !validEmail($scope.email) || $scope.processing;
    };

    $scope.doForgot = function() {
        $scope.processing = true;
        ferry.sessionless_perform('account.forgot_password', [ $scope.email.trim().toLowerCase() ]).then(() => {
            $location.path("/login/sent");
            $scope.$apply();
        }).catch(() => {
            $scope.ui.errorMessage = "Oops something went wrong...";
            $scope.processing = false;
            $scope.$apply();
        });
    };
}];



// WEBPACK FOOTER //
// ./_src/ui/preLoginApp/password/passwordForgot.js